import { useState, useCallback } from 'react'

const DEFAULT_TIMEOUT = 2000

export const useCopyWithFeedback = (
    timeout = DEFAULT_TIMEOUT
): [boolean, (value: string) => void] => {
    const [copied, setCopied] = useState(false)

    const copy = useCallback(
        (value: string) => {
            if (!value) return
            navigator.clipboard.writeText(value)
            setCopied(true)
            setTimeout(() => {
                setCopied(false)
            }, timeout)
        },
        [timeout]
    )

    return [copied, copy]
}
